import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icon (Leaflet + webpack issue)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const LocationMap = ({ location, country }) => {
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!location) { setLoading(false); setError(true); return; }
    const query = country ? `${location}, ${country}` : location;
    fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`, {
      headers: { 'Accept-Language': 'en' }
    })
      .then(res => res.json())
      .then(data => {
        if (data.length > 0) {
          setPosition([parseFloat(data[0].lat), parseFloat(data[0].lon)]);
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [location, country]);

  if (loading) {
    return (
      <div className="bg-gray-100 h-96 rounded-xl flex items-center justify-center">
        <div className="flex items-center gap-2 text-gray-500">
          <div className="h-5 w-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
          Loading map...
        </div>
      </div>
    );
  }

  if (error || !position) {
    return (
      <div className="bg-gray-100 h-96 rounded-xl flex items-center justify-center">
        <p className="text-gray-500">Map not available for this location</p>
      </div>
    );
  }

  return (
    <div className="h-96 rounded-xl overflow-hidden" data-testid="property-location-map">
      <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>{location}{country ? `, ${country}` : ''}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default LocationMap;
